module.exports = __webpack_public_path__ + "static/media/genealogia.cfa6beff.png";